import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { Typography, Slider, MenuItem, Select, Autocomplete, TextField } from "@mui/material";
import { GlobalData } from "../../util/GlobalData";
import HiveIcon from '@mui/icons-material/Hive';
import FilterListIcon from '@mui/icons-material/FilterList';
import TransformIcon from '@mui/icons-material/Transform';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import BusinessIcon from '@mui/icons-material/Business';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { CurrencyContext } from "../Utils";

export default function ProductsFilter({ title = "Filters", productList, pays, entreprises, defaultPriceRange, setFilteredList }) {
    const { t } = useTranslation()
    const [isFiltered, setisFiltered] = useState(false)
    const [priceRange, setpriceRange] = useState(defaultPriceRange)

    const [search, setSearch] = useState("");
    const [priceChanged, setPriceChanged] = useState(false);
    const [entreprise, setEntreprise] = useState("all");
    const [productionCountry, setProductionCountry] = useState("all");
    const [typologie, setTypologie] = useState("all");
    const [methodedecapture, setMethodedecapture] = useState("all");
    const [conservation, setconservation] = useState("all");
    const [congelation, setcongelation] = useState("all");
    const [emballage, setemballage] = useState("all");
    const [transformation, setTransformation] = useState("all");
    const [certification, setCertification] = useState("all");
    const { currency, getCurrencyPrice } = useContext(CurrencyContext)

    useEffect(() => {
        clearFilter()
    }, [defaultPriceRange])

    useEffect(() => {
        if ( entreprise != "all" || productionCountry != "all" || typologie != "all" || methodedecapture != "all" || conservation != "all" ||
            congelation != "all" || emballage != "all" || certification != "all" || transformation != "all" || search || priceChanged) {
            applyFilter()
        } else {
            setFilteredList(productList)
            setisFiltered(false)
        }
    }, [search, priceChanged, entreprise, productionCountry, typologie, methodedecapture, congelation, conservation, transformation, certification, emballage])


    const applyFilter = () => {
        setisFiltered(true)


        let result = productList;



        result = filterSearch(result)
        result = filterEntreprise(result);
        result = filterProductionCountry(result);
        result = filterTypologie(result);
        result = filterTypologie(result);
        result = filterConservation(result);
        result = filterCongelation(result);
        result = filterEmbalage(result);
        result = filterTransformation(result);
        result = filterMethode(result);
        result = filterPrice(result);


        setFilteredList(result)
    }


    const clearFilter = () => {
        setSearch("")
        setpriceRange(defaultPriceRange);
        setPriceChanged(false);
        setEntreprise("all");
        setCertification("all");
        setMethodedecapture("all");
        setTransformation("all");
        setTypologie("all");
        setProductionCountry("all")
        setconservation("all")
        setcongelation("all")
        setemballage("all")


        setisFiltered(false)
    };


    const filterConservation = (array) => {
        if (conservation != "all") {
            let newArray = [];
            array.forEach((item) => {
                if (item.conservation == conservation) {
                    newArray.push(item);
                }
            });
            return newArray;
        } else {
            return array;
        }
    };


    const filterCongelation = (array) => {
        if (congelation != "all") {
            let newArray = [];
            array.forEach((item) => {
                if (item.congelation == congelation) {
                    newArray.push(item);
                }
            });
            return newArray;
        } else {
            return array;
        }
    };


    const filterEmbalage = (array) => {
        if (emballage != "all") {
            let newArray = [];
            array.forEach((item) => {
                if (item.emballage == emballage) {
                    newArray.push(item);
                }
            });
            return newArray;
        } else {
            return array;
        }
    };



    const filterSearch = (array) => {
        if (search) {
            return array.filter((product) => {
                return (
                    product.nom
                        .toLowerCase()
                        .includes(search.toLowerCase()) ||
                    product.description
                        .toLowerCase()
                        .includes(search.toLowerCase())
                );
            })
        } else {
            return array;
        }
    };




    const filterPrice = (array) => {
        if (priceChanged) {
            return array.filter(
                (item) => getCurrencyPrice(item.prix, item.currency, currency) >= priceRange[0] && getCurrencyPrice(item.prix, item.currency, currency) <= priceRange[1]
            );
        } else {
            return array;
        }
    }




    const filterProductionCountry = (array) => {
        if (productionCountry != "all") {
            let newArray = [];
            array.forEach((item) => {
                if (item.productionCountry == productionCountry) {
                    newArray.push(item);
                }
            });
            return newArray;
        } else {
            return array;
        }
    }






    const filterEntreprise = (array) => {
        if (entreprise != "all") {
            let newArray = [];
            array.forEach((item) => {
                if (item.user?.entreprise?.id == entreprise) {
                    newArray.push(item);

                }
            });
            return newArray;
        } else {
            return array;
        }
    };


    const filterTypologie = (array) => {
        if (typologie != "all") {
            let newArray = [];
            array.forEach((item) => {
                if (item.typologie == typologie) {
                    newArray.push(item);
                }
            });
            return newArray;
        } else {
            return array;
        }
    };





    const filterMethode = (array) => {
        if (methodedecapture != "all") {
            let newArray = [];
            array.forEach((item) => {
                if (item.methodedecapture == methodedecapture) {
                    newArray.push(item);

                }
            });
            return newArray;
        } else {
            return array;
        }
    };


    const filterTransformation = (array) => {

        if (transformation != "all") {
            let newArray = [];
            array.forEach((item) => {

                if (item.transformation == transformation) {
                    newArray.push(item);

                }
            });
            return newArray;
        } else {
            return array;
        }
    };



    const filterCertifcation = (array) => {
        if (certification != "all") {
            let newArray = [];
            array.forEach((item) => {
                if (item.certification == certification) {
                    newArray.push(item);
                }
            });
            return newArray;
        } else {
            return array;
        }
    };















    const rangeSelector = (event, newValue) => {
        setpriceRange(newValue);

        if (newValue[0] == defaultPriceRange[0] && newValue[1] == defaultPriceRange[1]) {
            setPriceChanged(false);
        } else {
            setPriceChanged(true);
        }
    };

    return (
        <div className="col-md-3">
            <div className="d-flex align-items-center justify-content-center">

                <div className="filtre-marketplace">
                    <div className="filter-header">{title}</div>

                    <div className="marketplace-search-position has-search">
                        <i className="fa fa-search form-control-feedback"></i>
                        <input
                            type="text"
                            className="form-control input-search-marketplace"
                            placeholder={t("catalog3.1")}
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                            }}
                        />
                    </div>

                    <div className="filter-header-1">
                        <div style={{ marginTop: 3 }}>{t("Filtres.1")}</div>
                        {isFiltered && (
                            <>
                                <span onClick={clearFilter} className="remove-all-filter"><i className="fas fa-times"></i> &nbsp; {t("resetFilter")}</span>
                            </>
                        )}
                    </div>


                    <>
                        <hr />
                        <div className="filter-content">

                            <div className="prix">
                                <h5 className="filter-section-title">
                                    {t("Prix.1")}
                                </h5>
                                <Typography id="range-slider" gutterBottom>
                                    {t("Sélectionnez la gamme de prix.1")}
                                </Typography>
                                <div className="d-flex justify-content-center align-items-center text-center">
                                    <div
                                        style={{
                                            width: "90%",
                                        }}
                                    >
                                        <Slider
                                            value={priceRange}
                                            onChange={rangeSelector}
                                            valueLabelDisplay="auto"
                                            max={defaultPriceRange[1]}
                                            min={defaultPriceRange[0]}
                                            valueLabelFormat={value => currency + " " + value}
                                        />
                                        <div className="slider-bottom">
                                            <span>{GlobalData.currency[currency]}{priceRange[0]}</span>
                                            <span>{GlobalData.currency[currency]}{priceRange[1]}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />


    


                            <div className="categories">
                                <h5 className="filter-section-title" style={{ fontSize: 15 }}>
                                    {t("product.typologie")}
                                </h5>

                                <Select IconComponent={HiveIcon} value={typologie} onChange={(e) => { setTypologie(e.target.value) }} fullWidth >
                                    <MenuItem value={"all"}>
                                        {t("all")}
                                    </MenuItem>
                                    {GlobalData.product.typologies.map((val, index) => (
                                        <MenuItem key={index} value={val}>
                                            {t("product.typologies." + val)}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>



                            <hr />


                            <div className="categories">
                                <h5 className="filter-section-title" style={{ fontSize: 15 }}>
                                    {t("product.productionCountry")}
                                </h5>
                                <Autocomplete
                                    disablePortal
                                    fullWidth
                                    options={[{ label: t("all"), value: "all" }, ...(pays.map((val) => ({
                                        label: val.name,
                                        value: val.name
                                    })))]}
                                    value={productionCountry}
                                    onChange={(event, newValue) => {
                                        setProductionCountry(newValue?.value);
                                    }}
                                    renderInput={(params) => (
                                        <TextField  {...params} variant="outlined" />
                                    )}
                                    disableClearable={true}
                                />
                            </div>


                            <hr />

                            <div className="categories">
                                <h5 className="filter-section-title" style={{ fontSize: 15 }}>
                                    {t("catalog5.1")}
                                </h5>
                                <Select IconComponent={BusinessIcon} value={entreprise} onChange={(e) => { setEntreprise(e.target.value) }} fullWidth >
                                    <MenuItem value={"all"}>
                                        {t("all")}
                                    </MenuItem>
                                    {entreprises.map((val, index) => (
                                        <MenuItem key={index} value={val.id}>
                                            {val.nom || t("anonymous")}
                                        </MenuItem>
                                    ))}
                                </Select>


                            </div>
                            <hr />








                            <div className="categories">
                                <h5 className="filter-section-title" style={{ fontSize: 15 }}>
                                    {t("product.capture")}
                                </h5>
                                <Select IconComponent={FilterListIcon} value={methodedecapture} onChange={(e) => { setMethodedecapture(e.target.value) }} fullWidth >
                                    <MenuItem value={"all"}>
                                        {t("all")}
                                    </MenuItem>
                                    {GlobalData.product.captures.map((val, index) => (
                                        <MenuItem key={index} value={val}>
                                            {t("product.captures." + val)}
                                        </MenuItem>
                                    ))}
                                </Select>

                            </div>
                            <hr />




                            <div className="categories">
                                <h5 className="filter-section-title" style={{ fontSize: 15 }}>
                                    {t("product.conservation")}
                                </h5>
                                <Select IconComponent={TransformIcon} value={conservation} onChange={(e) => { setconservation(e.target.value) }} fullWidth >
                                    <MenuItem value={"all"}>
                                        {t("all")}
                                    </MenuItem>
                                    {GlobalData.product.conservations.map((val, index) => (
                                        <MenuItem key={index} value={val}>
                                            {t("product.conservations." + val)}
                                        </MenuItem>
                                    ))}
                                </Select>


                            </div>
                            <hr />



                            <div className="categories">
                                <h5 className="filter-section-title" style={{ fontSize: 15 }}>
                                    {t("product.transformation")}
                                </h5>
                                <Select IconComponent={MoveUpIcon} value={transformation} onChange={(e) => { setTransformation(e.target.value) }} fullWidth >
                                    <MenuItem value={"all"}>
                                        {t("all")}
                                    </MenuItem>
                                    {GlobalData.product.transformations.map((val, index) => (
                                        <MenuItem key={index} value={val}>
                                            {t("product.transformations." + val)}
                                        </MenuItem>
                                    ))}
                                </Select>

                            </div>
                            <hr />




                            <div className="categories">
                                <h5 className="filter-section-title" style={{ fontSize: 15 }}>
                                    {t("product.congelation")}
                                </h5>
                                <Select IconComponent={AcUnitIcon} value={congelation} onChange={(e) => { setcongelation(e.target.value) }} fullWidth >
                                    <MenuItem value={"all"}>
                                        {t("all")}
                                    </MenuItem>
                                    {GlobalData.product.congelations.map((val, index) => (
                                        <MenuItem key={index} value={val}>
                                            {t("product.congelations." + val)}
                                        </MenuItem>
                                    ))}
                                </Select>


                            </div>

                        </div>
                    </>

                </div>
            </div>
        </div>

    )
}











export function ProductsOrder({ items, setOrderedItems }) {
    const { t } = useTranslation()
    const [order, setOrder] = useState(0)


    useEffect(() => {
        onChangeOrder(order)
    }, [items])



    const onChangeOrder = (value) => {
        // ascending sort
        let orderedItems = [...items].sort((a, b) => ((a.discount ? (a.prix - (a.prix / 100 * a.discount)) : a.prix) - (b.discount ? (b.prix - (b.prix / 100 * b.discount)) : b.prix)))

        if (value == 1) {
            orderedItems.reverse()
        }

        setOrder(value)
        setOrderedItems(orderedItems)
    }

    return (
        <div className="col-md-12">
            <div className="section-title   seemore endsection">
                <div className="plus">
                    <div >
                        <span className="text-input">{t('catalog1.1')}</span>
                    </div>
                    <div>
                        <Select IconComponent={SwapVertIcon} value={order} onChange={(e) => { onChangeOrder(e.target.value) }} fullWidth >
                            <MenuItem value={0}>
                                {t("ascendingPrice")}
                            </MenuItem>
                            <MenuItem value={1}>
                                {t("descendingPrice")}
                            </MenuItem>
                        </Select>
                    </div>
                </div>
            </div>
        </div>
    )
}